import DateFnsUtils from '@date-io/date-fns';
import { Button } from 'primereact/button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Grid from "@material-ui/core/Grid";
import TextField from '@material-ui/core/TextField';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import "date-fns";
import { useFormik } from "formik";
import * as React from "react";
import * as yup from "yup";


export default function ProviderBlacklistModal(props) {
    const validationSchema = yup.object({
        remarks: yup.string("Enter your remarks").required("remark is required"),

    });
    const formik = useFormik({
        initialValues: {
            remarks: "",
            startDate: new Date().getTime()
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            handleModalSubmit();
        },
    });

    const [openBlacklistModal, setOpenBlacklistModal] = React.useState(false);
    // useEffect(() => {
    //     setOpenBlacklistModal(props.openBlacklistModal);
    // }, [props.openBlacklistModal]);


    const handleModalSubmit = (e) => {
        let payload = {
            startDate: formik.values.startDate,
            remarks: formik.values.remarks,
        }
        props.handleBlacklistSubmit(payload);
    }

    const handleClose = () => {
        props.closeBlacklistModal();
    }

    const [selectedStartDate, setSelectedStartDate] = React.useState(new Date());
    const handleStartDateChange = (date) => {
        setSelectedStartDate(date);
        const timestamp = new Date(date).getTime();
        formik.setFieldValue('startDate', timestamp);
    };


    return (

        <Dialog open={props.openBlacklistModal} onClose={handleClose} aria-labelledby="form-dialog-title" disableEnforceFocus>
            <DialogTitle id="form-dialog-title">Provider Blacklisting</DialogTitle>
            <DialogContent>
                <form onSubmit={formik.handleSubmit}>
                    <Grid container spacing={3} style={{ marginBottom: "20px" }}>
                        <Grid item xs={12}>
                            <TextField
                                id="standard-basic"
                                name="remarks"
                                value={formik.values.remarks}
                                onChange={formik.handleChange}
                                label="Remarks"
                            />

                        </Grid>
                        <Grid item xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                {/* <Grid container justify="space-around"> */}
                                <KeyboardDatePicker
                                    views={["year", "month", "date"]}
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    margin="normal"
                                    id="date-picker-inline"
                                    label="Start date"
                                    value={selectedStartDate}
                                    onChange={handleStartDateChange}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change ing date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                    </Grid>
                </form>


            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleModalSubmit} color="primary">
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
}